import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .ChallengesLeaderboardTable {
    :global(.RowLink) {
      @include respond-to(sm) {
        justify-content: center;
      }
    }

    :global(.ReactDataTable__wrapper) {
      :global(.ReactDataTable) {
        :global(.ReactDataTable__thead) {
          :global(tr) {
            :global(th) {
              :global(.ReactDataTable__thead-caption) {
                text-align: center;
              }
            }
          }
        }
        :global(tr) {
          grid-template-columns: minmax(100px, 1fr) minmax(150px, 3fr) repeat(4, minmax(50px, 1fr));

          @include respond-to(lg) {
            grid-template-columns: minmax(100px, 1fr) minmax(150px, 3fr) repeat(4, minmax(50px, 1fr));
          }
        }

        :global(.ReactDataTable__tbody-row) {
          height: 100px;
          transition: 0.4s transform;
          &:hover {
            transform: scale(1.02);
          }
        }

        :global(.ReactDataTable__thead-cell:not(:first-child), .ReactDataTable__tbody-cell:not(:first-child)) {
          display: flex;
          justify-content: center;
        }

        :global(.ReactDataTable__thead-cell:first-child, .ReactDataTable__tbody-cell:first-child) {
          padding-left: rem(20px) !important;
        }

        :global(.ChallengesLeaderboardTable__ProfitCell) {
          font-size: 14px;
          font-weight: 500;
          line-height: 19.6px;
          text-align: left;

          color: #000000;
        }

        :global(.ChallengesLeaderboardTable__EquityCell) {
          font-size: 14px;
          font-weight: 400;
          line-height: 19.6px;
          text-align: left;
          color: #00000080;
        }

        :global(.ChallengesLeaderboardTable__InitialAccountBalanceCell) {
          font-size: 14px;
          font-weight: 400;
          line-height: 19.6px;
          text-align: left;
          color: #00000080;
        }

        :global(.ChallengesLeaderboardTable__GainCell) {
          font-size: 14px;
          font-weight: 500;
          line-height: 19.6px;
          text-align: left;
          color: #000000;
        }
      }
    }
  }
`;

const getDynamicStyles = ({ colors }) => {
  return css``;
};

export { staticStyles, getDynamicStyles };
